import React, { useEffect, useRef } from 'react';
import { animate, useReducedMotion } from 'framer-motion';
import { formatNaira } from '../utils/format';

/** Counts smoothly between naira values when the amount changes. */
export function AnimatedNaira({
  value,
  className
}: {
  value: number;
  className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const previous = useRef(value);
  const reduce = useReducedMotion();
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (reduce) {
      node.textContent = formatNaira(value);
      previous.current = value;
      return;
    }
    const controls = animate(previous.current, value, {
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: latest => {
        node.textContent = formatNaira(latest);
      }
    });
    previous.current = value;
    return () => controls.stop();
  }, [value, reduce]);
  return <span ref={ref} className={className} data-id="element-26" data-mp="2u89fx6xgqjxp">
      {formatNaira(value)}
    </span>;
}